import { IssueStatusEnum } from 'src/utils/issue';

/** Every status is a lane, so every status stays reachable by drag. */
export const BOARD_LANES: IssueStatusEnum[] = [
  IssueStatusEnum.OPEN,
  IssueStatusEnum.IN_REVIEW,
  IssueStatusEnum.RESOLVED,
  IssueStatusEnum.REJECTED,
  IssueStatusEnum.CLOSED,
];

/** How many cards each lane fetches at a time. */
export const LANE_PAGE_SIZE = 50;

/**
 * The cards a dropped card lands between, as ids the server can resolve itself.
 *
 * `destinationIds` is the destination lane in lane order with the moved card already removed,
 * so a same-lane reorder resolves against where the remaining cards actually sit.
 * `insertIndex` is the slot it lands in, 0 through destinationIds.length.
 */
export function resolveNeighbours(
  destinationIds: string[],
  insertIndex: number
): { beforeId?: string; afterId?: string } {
  return {
    beforeId: destinationIds[insertIndex - 1],
    afterId: destinationIds[insertIndex],
  };
}
